<mat-tab-group mat-align-tabs="start" [backgroundColor]="'primary'" [color]="'accent'" style="width: 100%;">
    <mat-tab label="Member List">
        <app-member-list></app-member-list>
    </mat-tab>
    <mat-tab label="Member Stats">
        <app-member-stats></app-member-stats>
    </mat-tab>
    <mat-tab label="Messages">
        <app-app-messages></app-app-messages>
    </mat-tab>
    <mat-tab label="Marketing Channels">
        <app-marketing-channels></app-marketing-channels>
    </mat-tab>
    <mat-tab label="Data Delete" *ngIf="isSuperAdmin">
        <app-data-delete></app-data-delete>
    </mat-tab>
  </mat-tab-group>
